import { createFeatureSelector, createSelector } from '@ngrx/store';
import { initProducts, ProductState } from './ProductReducer';

export const selectProductState = createFeatureSelector<ProductState>('product');

export const initProductsSelector = createSelector(
  selectProductState,
  initProducts
);
